// import styles from './../../src/abstracts/_colors.scss';
const styles = {
  colorPrimary: { r: 228, g: 0, b: 43, a: 1, rgba: 'rgba(228, 0, 43, 1)' },
  colorSecondary: { r: 57, g: 67, b: 78, a: 1, rgba: 'rgba(57, 67, 78, 1)' },
  colorSecondaryLight: { r: 80, g: 88, b: 98, a: 1, rgba: 'rgba(80, 88, 98, 1)' },
  colorFont0: { r: 26, g: 31, b: 36, a: 1, rgba: 'rgba(26, 31, 36, 1)' },
  colorFont1: { r: 57, g: 67, b: 78, a: 1, rgba: 'rgba(57, 67, 78, 1)' },
  colorFont2: { r: 105, g: 118, b: 132, a: 1, rgba: 'rgba(105, 118, 132, 1)' },
  colorFont3: { r: 150, g: 161, b: 176, a: 1, rgba: 'rgba(150, 161, 176, 1)' },
  colorFont4: { r: 248, g: 249, b: 250, a: 1, rgba: 'rgba(248, 249, 250, 1)' },
  colorFont5: { r: 80, g: 90, b: 101, a: 1, rgba: 'rgba(80, 90, 101, 1)' },
  colorGa: { r: 226, g: 230, b: 234, a: 1, rgba: 'rgba(226, 230, 234, 1)' },
  colorWhite: { r: 255, g: 255, b: 255, a: 1, rgba: 'rgba(255, 255, 255, 1)' },
  colorA: { r: 255, g: 154, b: 43, a: 1, rgba: 'rgba(255, 154, 43, 1)' },
  colorB: { r: 255, g: 181, b: 5, a: 1, rgba: 'rgba(255, 181, 5, 1)' },
  colorTr: { r: 0, g: 0, b: 0, a: 0, rgba: 'rgba(0, 0, 0, 0)' },
  colorError: { r: 255, g: 128, b: 0, a: 1, rgba: 'rgba(255, 128, 0, 1)' },
  colorBorder: { r: 216, g: 219, b: 223, a: 1, rgba: 'rgba(216, 219, 223, 1)' },
  colorBorderDark: { r: 150, g: 161, b: 176, a: 1, rgba: 'rgba(150, 161, 176, 1)' },
  colorModalBg: { r: 240, g: 242, b: 245, a: 1, rgba: 'rgba(240, 242, 245, 1)' },
  colorInputBrAct: { r: 106, g: 119, b: 133, a: 1, rgba: 'rgba(106, 119, 133, 1)' },
  colors: {
    primary: { r: 228, g: 0, b: 43, a: 1, rgba: 'rgba(228, 0, 43, 1)' },
    secondary: { r: 57, g: 67, b: 78, a: 1, rgba: 'rgba(57, 67, 78, 1)' },
    'secondary-l': { r: 80, g: 88, b: 98, a: 1, rgba: 'rgba(80, 88, 98, 1)' },
    f0: { r: 26, g: 31, b: 36, a: 1, rgba: 'rgba(26, 31, 36, 1)' },
    f1: { r: 57, g: 67, b: 78, a: 1, rgba: 'rgba(57, 67, 78, 1)' },
    f2: { r: 105, g: 118, b: 132, a: 1, rgba: 'rgba(105, 118, 132, 1)' },
    f3: { r: 150, g: 161, b: 176, a: 1, rgba: 'rgba(150, 161, 176, 1)' },
    f4: { r: 248, g: 249, b: 250, a: 1, rgba: 'rgba(248, 249, 250, 1)' },
    f5: { r: 80, g: 90, b: 101, a: 1, rgba: 'rgba(80, 90, 101, 1)' },
    ga: { r: 226, g: 230, b: 234, a: 1, rgba: 'rgba(226, 230, 234, 1)' },
    w: { r: 255, g: 255, b: 255, a: 1, rgba: 'rgba(255, 255, 255, 1)' },
    a: { r: 255, g: 154, b: 43, a: 1, rgba: 'rgba(255, 154, 43, 1)' },
    tr: { r: 0, g: 0, b: 0, a: 0, rgba: 'rgba(0, 0, 0, 0)' },
    err: { r: 255, g: 128, b: 0, a: 1, rgba: 'rgba(255, 128, 0, 1)' },
    bg: { r: 240, g: 242, b: 245, a: 1, rgba: 'rgba(240, 242, 245, 1)' },
    border: { r: 216, g: 219, b: 223, a: 1, rgba: 'rgba(216, 219, 223, 1)' },
    borderdark: { r: 150, g: 161, b: 176, a: 1, rgba: 'rgba(150, 161, 176, 1)' }
  }
}
export default styles.colors;